import Swiper from 'swiper/js/swiper';
import { gsap } from 'gsap/dist/gsap';
// eslint-disable-next-line no-unused-vars
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {
    // JavaScript to be fired on the home page
    new Swiper ('.swiper-container-lightbox-accomodations', {
      // loop: true,
      slidesPerView: 1,
      // roundLengths: true,
      grabCursor: true,
      speed: 500,
      navigation: {
        nextEl: '.swiper-accommodation-lightbox-button-next',
        prevEl: '.swiper-accommodation-lightbox-button-prev',
      },
    })

    function pagePrivateRentalsLoadAnimation() {
      const tl = gsap.timeline({ delay: 0.5, duration: 0.5 })

      tl.to('.hero-single-rental .wrap-fullscreen-image', { opacity: 1 })
      .to('.hero-single-rental .dark-overlay-hero', { opacity: 1 }, '>-0.15')
      .to('.hero-single-rental .wrap-hero-header h1', { opacity: 1 }, '>-0.25')
    }
    pagePrivateRentalsLoadAnimation()
   
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-accommodations.js